import { render, staticRenderFns } from "./NewRirekishoJobHistoryCard.vue?vue&type=template&id=6c477a49"
import script from "./NewRirekishoJobHistoryCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewRirekishoJobHistoryCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports